import React, { Component } from "react";
import { CaretDown, CaretUp, Download, FileDocument, FileDownload } from "../normalizer";
import CustomLink from "../shared/CustomLink";

class DocumentCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: this.props.campaign,
      item: this.props.item,
      i: this.props.i,
      expanded: this.props.i == 0
    };
  }

  componentDidUpdate(oldprops) {
    if (this.props.item !== oldprops.item) {
      this.setState({
        item: this.props.item,
        campaign: this.props.campaign,
      });
    }
  }

  getColors() {
    return (
      this.state.campaign.template &&
      this.state.campaign.template.appearence &&
      this.state.campaign.template.appearence.colors
    );
  }

  showDocumentDetails(e, documentId) {
    e.preventDefault();
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }

  render() {
    return (
      <div className="document-card">
        <div className="document-card-icon-container">
          <div className="document-card-icon">
            <FileDocument />
          </div>
        </div>
        <div className="document-card-container">
          <div className="document-card-title">
            <div>{this.state.item.title}</div>
          </div>
          {this.state.expanded && (
            <div className="document-card-content" dangerouslySetInnerHTML={{ __html: this.state.item.body }} />
          )}
          <CustomLink tight
            onClick={(e) => this.showDocumentDetails(e, this.state.item.id)}
            className="document-card-expand"
          >
            {this.state.expanded ? "Ocultar detalhes" : "Ver detalhes"}
            {!this.state.expanded ? <CaretDown /> : <CaretUp />}
          </CustomLink>
        </div>
        <div className="document-card-action">
          {this.state.item.attachments[0] && (
            <CustomLink className="document-card-icon-link" to={this.state.item.attachments[0].url}>
              <Download />
            </CustomLink>
          )}
        </div>
      </div>
    );
  }
}
export default DocumentCard;
